module.exports = __webpack_public_path__ + "img/burnt-patch.8925bae1.png";